module.exports = __webpack_public_path__ + "static/media/info.0053f463.svg";